<template>
  <section
    class="component-ae9a2301"
    resmed-component-name="feature_fullwidth_icon-line_text_3cta"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div
      class="component"
      v-bind:class="{
        [`text-color-${acf.layout['text-color']}`]: true,
        [`text-${acf.layout['text-align']}`]: true,
        [`component-height-${acf.layout['component-height']}`]: true,
      }"
    >
      <figure
        class="embed-responsive"
        v-bind:style="styles"
        v-bind:class="{
          'embed-responsive-1by1': $root.mode === 'xs',
          'embed-responsive-4by3': $root.mode === 'sm' || $root.mode === 'md',
          'embed-responsive-16by9': $root.mode === 'lg',
          'embed-responsive-2880by1300': $root.mode === 'xl',
        }"
      ></figure>
      <div
        class="wrapper px-xs-sm-2"
        v-bind:class="[`align-${acf.layout['align']}`]"
      >
        <div class="container">
          <div
            class="row"
            v-bind:class="{
              'justify-content-center': acf.layout['text-align'] === 'center',
            }"
          >
            <div
              class="col"
              v-bind:class="{
                'offset-lg-1': acf.layout['text-align'] !== 'center',
                'col-lg-10': acf.layout['text-align'] === 'center',
              }"
            >
              <figcaption>
                <eyebrow-icon
                  v-if="acf.eyebrowicon"
                  v-bind:eyebrowicon="acf.eyebrowicon"
                  v-bind:align="
                    acf.layout['text-align'] === 'center' ? 'center' : ''
                  "
                ></eyebrow-icon>
                <h2 class="heading-lg" v-if="acf.layout['h-type'] === 'h2'" v-html="acf.headline"></h2>
                <h1 class="heading-xl" v-else v-html="acf.headline"></h1>

                <p v-if="acf.content" class="mb-4" v-html="acf.content"></p>
              </figcaption>

              <div class="row items" v-if="acf.items">
                <div class="col-md-4" v-for="(item, index) in acf.items">
                  <div class="content mb-5 mb-md-0">
                    <h5 style="font-size: 1.3rem;">{{ item.title }}</h5>
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>

              <div class="resources">
                <a
                  v-for="item in acf.cta"
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="btn cta-pill filled-red icon right-arrow ctaButtonLight"
                  v-bind:class="{
                    'mr-3': acf.layout['text-align'] !== 'center',
                  }"
                  >{{ item.cta.text }}</a
                >
                <a
                  v-if="acf['google-play']"
                  target="_blank"
                  :class="getGooglePlayIcon()"
                  v-bind:href="acf['google-play']"
                  class="mr-3 btn google-play d-block text-hide"
                  >Get it on Google Play</a
                >
                <a
                  v-if="acf['apple-app-store']"
                  target="_blank"
                  v-bind:href="acf['apple-app-store']"
                  class="btn apple-store d-block text-hide"
                  v-bind:class="getAppDownloadIcon()"
                  >Download on the App Store</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ae9a2301", // feature_fullwidth_icon-line_text_3cta
  props: ["acf"],
  data() {
    return {
      styles: {
        "background-color": this.acf.layout["background-color"],
      },
    };
  },

  methods:{
    getGooglePlayIcon() {
      const region = this.$route.params.region;
      if (region === "en-au") {
        return "google-play-en-au";
      } else if (region === "sv-se") {
        return "google-play-sv-se";
      } else if (region === "nb-no") {
        return "google-play-nb-no";
      } else {
        return "google-play-en-au";
      }
    },
    getAppDownloadIcon() {
      const region = this.$route.params.region;
      if (region === "en-au") {
        return "app-play-en-au";
      } else if (region === "sv-se") {
        return "app-play-sv-se";
      } else if (region === "nb-no") {
        return "app-play-nb-no";
      } else {
        return "app-play-en-au";
      }
    },
  },
  watch: {
    "$root.mode": {
      handler(val) {
        this.styles = Object.assign({}, this.styles, {
          "background-position": "center center",
          "background-image": `url(${this.acf.layout["background-image"]})`,
        });

        if (["xs", "sm"].includes(val)) {
          this.$set(this.styles, "background-position", "center top");

          if (this.acf.layout["background-image-xs"]) {
            this.$set(
              this.styles,
              "background-image",
              `url(${this.acf.layout["background-image-xs"]})`
            );
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ae9a2301 {
  // -->
}

.component {
  position: relative;

  &.text-center {
    figcaption {
      margin: 0 auto;
    }

    h1,
    h2 {
      @extend %eyebrow-center;
      &:before {
        background-color: $cc-resmed-white;
      }
    }

    .items {
      .content {
        @media (min-width: 992px) {
          padding: 0 1rem;
        }
      }
    }

    .resources {
      justify-content: center;

      .btn {
        @media (max-width: 767px) {
          margin-right: auto;
          margin-left: auto;
        }

        @media (min-width: 768px) {
          margin-right: 1.5rem;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  &.text-color-black {
    h1,
    h2,
    h5,
    p {
      color: $cc-resmed-black;
    }

    h1,
    h2 {
      &:before {
        background-color: $cc-resmed-black;
      }
    }
  }

  &.component-height-fixed {
    .wrapper {
      @media (min-width: 768px) {
        padding-top: 5rem;
        padding-bottom: 4rem;

        position: absolute;
        bottom: 0;
        padding-bottom: 60px;

        &.align-center {
          top: 50%;
          transform: translateY(-50%);
        }

        &.align-bottom {
          // default
        }
      }

      @media (min-width: 992px) {
        padding-bottom: 100px;
      }
    }

    @media (max-width: 767px) {
      figure {
        position: absolute !important;
        height: 100% !important;
        opacity: 0.6;
      }
    }
  }

  &.component-height-flex {
    figure {
      position: absolute;
      height: 100%;
    }
  }

  figure {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    @media (max-width: 575px) {
      background-position: center center;
    }

    @media (max-width: 767px) {
      width: 100vw;
      height: auto;
      bottom: auto;
    }
  }

  .wrapper {
    min-width: 100vw;
    padding-top: 5rem;
    padding-bottom: 4rem;
  }

  h1,
  h2 {
    position: relative;
    color: rgba($cc-resmed-white, 0.875);

    @media (min-width: 768px) {
      margin: 0 0 1.325rem 0;
    }

    @extend %eyebrow-left;
    &:before {
      background-color: $cc-resmed-white;
    }
  }

  h5 {
    margin-bottom: 0.625rem;
  }

  figcaption {
    max-width: 490px;
  }

  .items {
    @media (min-width: 768px) {
      margin-bottom: 2.25rem;
    }

    * {
      color: $cc-resmed-white;
    }

    .content {
      @media (min-width: 992px) {
        padding-right: 3rem;
      }
    }
  }

  .resources {
    > *:not(:last-child) {
      @media (max-width: 767px) {
        margin-bottom: 1.5rem;
      }
    }

    @media (min-width: 768px) {
      display: flex;
      align-items: center;
    }
  }
}
</style>
